function matchHeightWithinSection(section) {
  const elements = section.querySelectorAll('.match-height');
  if (!elements.length) return;

  // reset first so we measure natural heights
  elements.forEach(el => (el.style.height = 'auto'));
  const maxHeight = Math.max(...Array.from(elements).map(el => el.offsetHeight));
  elements.forEach(el => (el.style.height = maxHeight + 'px'));
}

function resetMatchHeightWithinSection(section) {
  const elements = section.querySelectorAll('.match-height');
  elements.forEach(el => (el.style.height = 'auto'));
}

function initMatchHeight(e) {
  const mql = e?.matches !== undefined ? e : window.matchMedia('(min-width: 768px)');
  const sections = document.querySelectorAll('section');

  if (mql.matches) {
    sections.forEach(section => matchHeightWithinSection(section));
  } else {
    sections.forEach(section => resetMatchHeightWithinSection(section));
  }
}

const mql = window.matchMedia('(min-width: 768px)');

// Media query listener
if ('addEventListener' in mql) {
  mql.addEventListener('change', initMatchHeight);
} else if ('addListener' in mql) {
  mql.addListener(initMatchHeight);
}

// Throttled resize handler
let resizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => initMatchHeight(mql), 100);
});

// Run once on load
window.addEventListener('load', () => {
  setTimeout(() => initMatchHeight(mql), 50);
});